<div class="container px-5 pt-5 mt-md-3">
  <div class="row mb-3">
    <div class="col-12">
      <button (click)="goBackToDashboard()" class="btn btn-outline-success btn-lg bg-white go-back-btn" type="button">
        {{ backButtonTranslation | translate }}
      </button>
    </div>
  </div>
</div>
@if (eligibilityCheckForm) {
<div class="container px-5 pt-5 mt-md-3">
  <div class="row form-group required" [formGroup]="eligibilityCheckForm">
    <div class="col-12 text-center">
      <div class="row pb-3 pb-md-2 justify-content-center">
        <span
          [ngClass]="{'text-danger': requestedEffectiveDate.invalid && (requestedEffectiveDate.dirty || requestedEffectiveDate.touched)}"
          class="control-label"
          >{{'common.formFieldsLabels.effectiveDate' | translate}}
        </span>
      </div>
      <div class="row pb-3 pb-md-2 justify-content-center">
        <div class="col-12 col-md-3 input-group">
          <input
            [dropSpecialCharacters]="false"
            [ngClass]="{'is-invalid': requestedEffectiveDate.invalid && (requestedEffectiveDate.dirty || requestedEffectiveDate.touched)}"
            class="form-control"
            formControlName="requestedEffectiveDate"
            mask="M0/d0/0000"
            name="requestedEffectiveDate"
            placeholder="MM/DD/YYYY"
            type="text"
            AutocompleteOffDirective
          />
          @if (requestedEffectiveDate?.errors?.required) {
          <div class="invalid-feedback">{{'common.formErrors.required' | translate}}</div>
          } @if (requestedEffectiveDate?.errors?.mask) {
          <div class="invalid-feedback">{{'common.formErrors.format' | translate: {format: 'MM/DD/YYYY'} }}</div>
          } @if (requestedEffectiveDate?.errors?.invalidDate) {
          <div class="invalid-feedback">{{'common.formErrors.invalidValue' | translate}}</div>
          } @if (requestedEffectiveDate?.errors?.firstDayOfMonth) {
          <div class="invalid-feedback">{{'common.formErrors.firstOfMonth' | translate}}</div>
          } @if (requestedEffectiveDate?.errors?.dateRange) {
          <div class="invalid-feedback">
            {{'common.formErrors.range' | translate: { 'min': requestedEffectiveDate?.errors?.dateRange?.min, 'max':
            requestedEffectiveDate?.errors?.dateRange?.max } }}
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row pb-3 pb-md-2 justify-content-center">
    <div class="col-12 col-md-3 d-flex justify-content-center">
      <button (click)="resolveApplicationYear()" class="btn btn-success btn-lg" type="button">
        {{ translationPrefix + '.actions.resolveYear' | translate }}
      </button>
    </div>
  </div>
</div>
}
